/* ============================================================
   PILLAR QUIZ — Quel encens est fait pour vous ?
   4 questions · scoring 5 issues · transitions fade · progress bar
   ============================================================ */

(function () {
  'use strict';

  var ICONS = {
    b: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="20" y1="36" x2="20" y2="12"/><circle cx="20" cy="10" r="1.4" fill="currentColor" stroke="none"/><path d="M20 7 Q 17 5, 19 3 Q 21 1, 18 -1" opacity="0.55"/><path d="M14 36 L 26 36 L 24 39 L 16 39 Z"/></svg>',
    cc: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M14 34 L 20 14 L 26 34 Z"/><circle cx="20" cy="12" r="1.4" fill="currentColor" stroke="none"/><path d="M20 9 Q 17 7, 19 5 Q 21 3, 18 1" opacity="0.55"/><line x1="10" y1="36" x2="30" y2="36"/></svg>',
    cr: '<svg viewBox="0 0 40 50" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18 L 20 4 L 26 18 Z"/><circle cx="20" cy="2.5" r="1.2" fill="currentColor" stroke="none"/><line x1="12" y1="20" x2="28" y2="20"/><path d="M16 24 Q 14 30, 17 36 Q 19 41, 14 46"/><path d="M24 24 Q 26 30, 23 36 Q 21 41, 26 46"/><line x1="10" y1="48" x2="30" y2="48"/></svg>',
    r: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14 C 14 18, 12 26, 14 31 C 16 35, 24 35, 26 31 C 28 26, 26 18, 20 14 Z"/><line x1="9" y1="38" x2="31" y2="38"/><path d="M20 11 C 17 9, 22 7, 19 5 C 16 3, 21 1, 18 -1" opacity="0.55"/></svg>',
    p: '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 36 Q 20 40 34 36"/><line x1="6" y1="36" x2="34" y2="36"/><path d="M13 36 Q 20 20 27 36"/><circle cx="20" cy="22" r="1.2" fill="currentColor" stroke="none"/><path d="M20 19 C 17 17, 22 15, 19 13 C 16 11, 21 9, 18 7" opacity="0.55"/></svg>'
  };

  var QUIZ_DATA = {
    questions: [
      {
        text: "Quel est votre rapport actuel à l'encens ?",
        options: [
          { label: "Je débute, je veux quelque chose de simple", scores: { b: 3, cc: 2 } },
          { label: "J'ai mes habitudes, je cherche à élargir", scores: { cr: 2, r: 1, p: 1 } },
          { label: "Je pratique régulièrement, je veux approfondir", scores: { r: 3, p: 2 } },
          { label: "Je collectionne déjà rituels et matières rares", scores: { p: 3, r: 2 } }
        ]
      },
      {
        text: "Pour quel usage principal ?",
        options: [
          { label: "Ambiance quotidienne, fond olfactif léger", scores: { b: 3 } },
          { label: "Marquer un moment (méditation, lecture, transition)", scores: { b: 2, cc: 2 } },
          { label: "Effet visuel spectaculaire (cascade de fumée)", scores: { cr: 3 } },
          { label: "Rituel profond, purification, cérémonie", scores: { r: 3, p: 1 } },
          { label: "Pratique contemplative type Kōdō, précision du geste", scores: { p: 3, r: 1 } }
        ]
      },
      {
        text: "Combien de temps voulez-vous que ça brûle ?",
        options: [
          { label: "Court (5 à 15 min), je veux pouvoir partir vite", scores: { cc: 3, cr: 1 } },
          { label: "Modéré (20 à 45 min), le temps d'une séance", scores: { b: 3, r: 1, p: 1 } },
          { label: "Long (1 h+) ou modulable selon la dose", scores: { p: 3, r: 2 } }
        ]
      },
      {
        text: "Quelle approche du matériel ?",
        options: [
          { label: "Le moins possible, je veux poser et allumer", scores: { b: 3 } },
          { label: "J'aime un bel objet visuel qui scénarise", scores: { cr: 3, cc: 1 } },
          { label: "Je suis prêt à manipuler charbon + cendre + brûleur", scores: { r: 3, p: 2 } },
          { label: "Je veux précision et dosage maîtrisé", scores: { p: 3 } }
        ]
      }
    ],
    results: {
      b: {
        title: "Le bâton d'encens — la voie de la simplicité",
        text: "Vous cherchez quelque chose de simple, fiable et constant. Les bâtons d'encens sont la porte d'entrée naturelle : un geste, une flamme, et 20 à 60 minutes de diffusion régulière. Notre sélection privilégie les compositions naturelles aux matières premières identifiables — santal vieilli, bois d'agar, encens japonais traditionnel, Nag Champa indien.",
        ctaMain: { label: "Voir tous les bâtons d'encens", url: "/collections/batons-d-encens" },
        ctaUpsell: { label: "Trouver le porte-encens adapté", url: "/collections/porte-encens-batons" }
      },
      cc: {
        title: "Le cône d'encens — l'intensité concentrée",
        text: "Vous voulez transformer l'atmosphère d'une pièce en quelques minutes. Les cônes d'encens offrent une combustion rapide (10 à 25 minutes) et une intensité marquée — idéal pour les usages ponctuels, l'accueil d'invités ou les rituels de recentrage.",
        ctaMain: { label: "Voir tous les cônes d'encens", url: "/collections/cones-encens" },
        ctaUpsell: { label: "Choisir un brûleur stable", url: "/collections/bruleurs-d-encens" }
      },
      cr: {
        title: "Le cône à reflux — la cascade contemplative",
        text: "Vous êtes attiré par l'aspect visuel et sculpté. Les cônes à reflux libèrent une fumée plus dense qui s'écoule vers le bas en cascade hypnotique, mise en scène par une fontaine d'encens dédiée. Effet sculptural qui transforme l'objet en pièce contemplative. Vous pouvez aussi explorer les cônes Kōdō traditionnels en bois d'agar (Wu, aquatique, Qi Nan) pour une approche plus avancée.",
        ctaMain: { label: "Voir tous les cônes d'encens", url: "/collections/cones-encens" },
        ctaUpsell: { label: "Découvrir nos fontaines à cascade", url: "/collections/fontaine-cascade-encens" }
      },
      r: {
        title: "La résine d'encens — l'héritage rituel",
        text: "Vous cherchez la forme la plus ancienne et la plus brute de l'encens. Les résines — oliban, myrrhe, benjoin, sang de dragon — sont issues de la sève solidifiée d'arbres aromatiques et brûlées sur charbon ardent. Cette pratique demande une gestuelle attentive qui s'inscrit naturellement dans une démarche contemplative.",
        ctaMain: { label: "Voir toutes les résines", url: "/collections/encens-resines" },
        ctaUpsell: { label: "Kits charbon + cendre + brûleur", url: "/collections/kits-accessoires-encens" }
      },
      p: {
        title: "La poudre d'encens — la voie de la précision",
        text: "Vous êtes attiré par la maîtrise du geste et la modulation de l'intensité. Les poudres d'encens sont au cœur des arts contemplatifs japonais Kōdō (香道, « la voie du parfum ») et chinois Xiangdao. Notre sélection inclut les poudres florales classiques (santal, rose, jasmin) ainsi que les poudres Xiangdao avancées pour encens-sceau, pour les pratiquants plus initiés.",
        ctaMain: { label: "Voir toutes les poudres", url: "/collections/encens-poudres" },
        ctaUpsell: { label: "Choisir un brûleur à fond plat", url: "/collections/bruleurs-d-encens" }
      }
    }
  };

  function initQuiz(root) {
    var engine = root.querySelector('[data-pq-engine]');
    if (!engine) return;

    var stateIntro = engine.querySelector('[data-pq-state="intro"]');
    var stateQuestion = engine.querySelector('[data-pq-state="question"]');
    var stateResult = engine.querySelector('[data-pq-state="result"]');
    var startBtn = engine.querySelector('[data-pq-start]');
    var backBtn = engine.querySelector('[data-pq-back]');
    var restartBtn = engine.querySelector('[data-pq-restart]');
    var qTitle = engine.querySelector('[data-pq-question]');
    var qOptions = engine.querySelector('[data-pq-options]');
    var pCurrent = engine.querySelector('[data-pq-progress-current]');
    var pTotal = engine.querySelector('[data-pq-progress-total]');
    var pFill = engine.querySelector('[data-pq-progress-fill]');
    var rIcon = engine.querySelector('[data-pq-result-icon]');
    var rTitle = engine.querySelector('[data-pq-result-title]');
    var rText = engine.querySelector('[data-pq-result-text]');
    var rMain = engine.querySelector('[data-pq-result-cta-main]');
    var rMainLabel = engine.querySelector('[data-pq-result-cta-main-label]');
    var rUpsell = engine.querySelector('[data-pq-result-cta-upsell]');
    var rUpsellLabel = engine.querySelector('[data-pq-result-cta-upsell-label]');

    var state = {
      qIndex: 0,
      scores: { b: 0, cc: 0, cr: 0, r: 0, p: 0 },
      history: []
    };

    pTotal.textContent = QUIZ_DATA.questions.length;

    function show(stateEl) {
      [stateIntro, stateQuestion, stateResult].forEach(function (s) { s.hidden = (s !== stateEl); });
      stateEl.classList.remove('is-fading-in');
      // double-RAF for fade-in
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          stateEl.classList.add('is-fading-in');
        });
      });
    }

    function scrollIntoView() {
      var rect = root.getBoundingClientRect();
      var stickyHeader = document.querySelector('sticky-header');
      var headerOffset = stickyHeader ? stickyHeader.offsetHeight + 16 : 80;
      if (rect.top < headerOffset || rect.top > window.innerHeight * 0.4) {
        var targetY = rect.top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }

    function renderQuestion() {
      var q = QUIZ_DATA.questions[state.qIndex];
      qTitle.textContent = q.text;
      pCurrent.textContent = (state.qIndex + 1);
      var pct = ((state.qIndex + 1) / QUIZ_DATA.questions.length) * 100;
      pFill.style.width = pct + '%';
      qOptions.innerHTML = '';
      q.options.forEach(function (opt, idx) {
        var li = document.createElement('li');
        li.className = 'pq-options__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pq-option';
        btn.innerHTML = '<span class="pq-option__dot" aria-hidden="true"></span><span class="pq-option__label">' + opt.label + '</span>';
        btn.addEventListener('click', function () { onAnswer(idx); });
        li.appendChild(btn);
        qOptions.appendChild(li);
      });
      backBtn.hidden = (state.qIndex === 0);
      show(stateQuestion);
    }

    function onAnswer(optIdx) {
      var q = QUIZ_DATA.questions[state.qIndex];
      var opt = q.options[optIdx];
      state.history.push({ qIndex: state.qIndex, scores: Object.assign({}, opt.scores) });
      Object.keys(opt.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) + opt.scores[k];
      });
      if (state.qIndex < QUIZ_DATA.questions.length - 1) {
        state.qIndex++;
        renderQuestion();
      } else {
        renderResult();
      }
    }

    function onBack() {
      if (state.qIndex === 0 || state.history.length === 0) return;
      var last = state.history.pop();
      Object.keys(last.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) - last.scores[k];
      });
      state.qIndex--;
      renderQuestion();
    }

    function pickWinner() {
      var keys = Object.keys(state.scores);
      var winner = keys[0];
      var max = -Infinity;
      keys.forEach(function (k) {
        if (state.scores[k] > max) { max = state.scores[k]; winner = k; }
      });
      return winner;
    }

    function renderResult() {
      var winner = pickWinner();
      var r = QUIZ_DATA.results[winner];
      if (rIcon) {
        rIcon.innerHTML = ICONS[winner] || '';
        rIcon.setAttribute('data-pq-icon-key', winner);
      }
      rTitle.textContent = r.title;
      rText.textContent = r.text;
      rMainLabel.textContent = r.ctaMain.label;
      rMain.setAttribute('href', r.ctaMain.url);
      rUpsellLabel.textContent = r.ctaUpsell.label;
      rUpsell.setAttribute('href', r.ctaUpsell.url);
      // GA4 / Shopify analytics event
      try {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'pillar_quiz_result', quiz_winner: winner });
        }
        if (window.gtag) { window.gtag('event', 'pillar_quiz_result', { quiz_winner: winner }); }
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('pillar_quiz_result', { quiz_winner: winner });
        }
      } catch (e) {}
      show(stateResult);
    }

    function onRestart() {
      state.qIndex = 0;
      state.scores = { b: 0, cc: 0, cr: 0, r: 0, p: 0 };
      state.history = [];
      show(stateIntro);
      scrollIntoView();
    }

    startBtn.addEventListener('click', function () {
      try {
        if (window.dataLayer) window.dataLayer.push({ event: 'pillar_quiz_start' });
        if (window.gtag) window.gtag('event', 'pillar_quiz_start');
      } catch (e) {}
      renderQuestion();
      scrollIntoView();
    });

    backBtn.addEventListener('click', onBack);
    restartBtn.addEventListener('click', onRestart);

    // Affiche l'intro au démarrage (corrige le bug du state opacity:0 invisible avant clic)
    show(stateIntro);
  }

  function bootAll() {
    document.querySelectorAll('.pq-section').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
